export const FETCH_HOW_TO_REQUEST = 'HOW_TO/FETCH_HOW_TO_REQUEST';
export const FETCH_HOW_TO_FAILURE = 'HOW_TO/FETCH_HOW_TO_FAILURE';
export const FETCH_HOW_TO_SUCCESS = 'HOW_TO/FETCH_HOW_TO_SUCCESS';
